import PropTypes from "prop-types";
import classNames from "classnames";
import Description from "../Description/component";
import LinkWrap from "../LinkWrap/component";

/**
 * Function representing the ImageButtonWidget component.
 * @param {Object} props The component props
 * @returns {React.Component} Returns the ImageButtonWidget component
 */
const ImageButtonWidget = ({
    url = "",
    imageURL = "",
    imageAlt = "",
    descriptionId = "",
    external = true,
    description = "",
    callToActionText = "",
}) => {
    const getDescription = (description, descriptionId) => {
        return (
            description &&
            descriptionId && (
                <Description id={descriptionId} text={description} />
            )
        );
    };

    // Dynamically assign classNames.
    const widgetClasses = classNames("imageButtonWidget", [descriptionId]);
    const imgClasses = description
        ? classNames("buttonImage", "imgWithDescription")
        : "buttonImage";

    return (
        <div className={widgetClasses} data-testid="image-button-widget">
            <h3>
                <img
                    className={imgClasses}
                    src={imageURL}
                    alt={imageAlt}
                    loading="lazy"
                />
            </h3>
            {getDescription(description, descriptionId)}
            <LinkWrap url={url} external={external}>
                {callToActionText}
            </LinkWrap>
        </div>
    );
};

ImageButtonWidget.propTypes = {
    url: PropTypes.string,
    imageURL: PropTypes.string,
    imageAlt: PropTypes.string,
    descriptionId: PropTypes.string,
    external: PropTypes.bool,
};

export default ImageButtonWidget;
